import { getBackVersion } from '../../config';
import api from '../api';

const removeLandlordFromProperty = (
    landlordId: number,
    propertyId: number
): Promise<void> =>
    api.request({
        method: 'DELETE',
        url: `${getBackVersion()}/agent/rental/landlord/${landlordId}/property/${propertyId}`,
    });

export { removeLandlordFromProperty };
